export default __webpack_public_path__ + "static/media/roz2-big.5c683519.png";